import React from "react";
import Marquee from "react-fast-marquee";
import { TrendingUp, TrendingDown } from "lucide-react";

/**
 * Ticker bar — shows live workspace metrics that are computed from real data.
 *
 * IMPORTANT: This component renders ONLY real values. If `items` is empty
 * (e.g. a brand-new workspace with no sources yet), the bar renders nothing.
 * We deliberately do NOT seed cosmetic / random values here — that would mis-
 * represent the platform to customers and investors.
 *
 * If `delta` on an item is null/undefined, the trend arrow + percentage is
 * omitted from that chip. The chip still displays its real value.
 */
export default function Ticker({ items = [] }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="border-y border-zinc-900 bg-black py-2" data-testid="ticker-bar">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {items.map((t, i) => {
          const hasDelta = t.delta !== null && t.delta !== undefined;
          const up = hasDelta && t.delta >= 0;
          return (
            <span key={i} className="ticker-item font-mono text-[11px] tracking-wider uppercase">
              <span className="text-zinc-500">{t.label}</span>
              <span className="text-white font-semibold">{t.value}</span>
              {hasDelta && (
                <span className={`flex items-center gap-1 ${up ? "text-[#00E676]" : "text-[#FF3B30]"}`}>
                  {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                  {Math.abs(t.delta).toFixed(2)}%
                </span>
              )}
              <span className="text-zinc-800">│</span>
            </span>
          );
        })}
      </Marquee>
    </div>
  );
}
